enum CustomURLParams {
  WithPredefinedFilters = 'withPredefinedFilters',
}

export default CustomURLParams;
